module.exports = __webpack_public_path__ + "static/media/final-page-header.282a6c24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/final-page-header.png
// module id = 395
// module chunks = 0